import _Box from "@mui/material/Box";
import _LinearProgress from "@mui/material/LinearProgress";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { Trans } from 'react-i18next';
import { useChallenge, useUnits } from '../../hooks';
import { CupIcon } from '../icons';
export function ChallengeCardProgressionHighlight({
  challenge,
  enableUserProgression,
  userChallenge,
  teamLeaderboard
}) {
  const {
    toOrdinal
  } = useUnits();
  const {
    getProgressValue,
    getFormattedProgressValue
  } = useChallenge();
  if (userChallenge === null) return /*#__PURE__*/React.createElement(React.Fragment, null);
  if (challenge && (challenge.period === 'future' || challenge.collaborationType !== 'global' && !enableUserProgression)) return /*#__PURE__*/React.createElement(React.Fragment, null);
  if (!challenge || challenge.targetValue && challenge.collaborationType === 'global') {
    return /*#__PURE__*/React.createElement(_Box, {
      bgcolor: "#ECFBF4",
      borderRadius: 2,
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      gap: 1,
      marginTop: 1,
      padding: 2
    }, /*#__PURE__*/React.createElement(_Typography, {
      variant: "body2"
    }, challenge ? getFormattedProgressValue(challenge, {
      highlight: true
    }) : /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: "100"
    })), challenge ? /*#__PURE__*/React.createElement(_LinearProgress, {
      sx: {
        height: 8,
        '.MuiLinearProgress-bar': {
          bgcolor: '#2AC682'
        }
      },
      title: `${challenge.progressPercentage} %`,
      value: challenge.progressPercentage,
      variant: "determinate"
    }) : /*#__PURE__*/React.createElement(_Skeleton, {
      height: 8,
      variant: "rounded",
      width: "100%"
    }));
  }
  const displayTeamProgression = challenge.collaborationType === 'teams';
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: userChallenge ? '#FFF5D0' : '#efefef',
    borderRadius: 2,
    display: "flex",
    flexDirection: "row",
    flexShrink: 0,
    gap: 1,
    marginTop: 1,
    padding: 2
  }, /*#__PURE__*/React.createElement(CupIcon, {
    fontSize: "small",
    sx: {
      color: userChallenge ? '#EBAF25' : 'rgba(0, 0, 0, 0.54)'
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, userChallenge ? /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("span", {
      key: 0,
      style: {
        fontWeight: 700
      }
    })],
    context: displayTeamProgression ? 'team' : '',
    count: displayTeamProgression ? undefined : challenge.nbMembers,
    i18nKey: "commons.challenges.rank",
    values: displayTeamProgression ? {
      rank: teamLeaderboard ? toOrdinal(teamLeaderboard.rank, {
        feminine: true
      }) : '-',
      count: teamLeaderboard?.countSubgroupOfSameType || '-'
    } : {
      rank: userChallenge.rank !== undefined ? toOrdinal(userChallenge.rank, {
        inclusive: true
      }) : '-',
      count: challenge.nbMembers,
      progress: getProgressValue(challenge.type, userChallenge.progressValue)
    }
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })));
}